import { state } from 'cerebral/tags'
import { set, when } from 'cerebral/operators'
import deselectAllFiles from 'modules/Media/chains/deselectAllFiles'
import selectTreeNodes from 'modules/Node/actions/selectTreeNodes'

function setCurrentView({ view, showSort }) {
  return [
    ...deselectAllFiles,
    selectTreeNodes,
    when(state`app.currentView`, view => view === 'startpage'),
    {
      true: set(state`node.tree.open`, true),
      false: []
    },
    set(state`node.showMenuToggle`, true),
    set(state`app.showSort`, showSort),
    set(state`app.currentView`, view)
  ]
}

export default setCurrentView



// WEBPACK FOOTER //
// ./src/modules/App/factories/setCurrentView.js